import { theme } from "../tokens"

export type ColorsType = keyof typeof theme | "transparent" | "current"

export const getCSSVariableThemeColor = (colorThemeName: ColorsType) => {
  return `var(--c-${colorThemeName})`
}

export const getComputedThemeColor = (colorThemeName: ColorsType) => {
  if (colorThemeName === "current") return "currentColor"
  if (colorThemeName === "transparent") return "transparent"

  const styles = getComputedStyle(document.documentElement)
  return styles.getPropertyValue(`--c-${colorThemeName}`)
}
